module.exports = __webpack_public_path__ + "img/forgotten.97f39b76.jpg";